/**
 * Chart Colors Configuration
 * Theme-aware color palettes for Chart.js
 */
export const chartColors = {
    light: {
        primary: 'rgba(13, 110, 253, 0.7)',
        success: 'rgba(25, 135, 84, 0.7)',
        danger: 'rgba(220, 53, 69, 0.7)',
        warning: 'rgba(255, 193, 7, 0.7)',
        info: 'rgba(13, 202, 240, 0.7)',
        secondary: 'rgba(108, 117, 125, 0.7)',
        light: 'rgba(248, 249, 250, 0.7)',
        dark: 'rgba(33, 37, 41, 0.7)',
    },
    dark: {
        primary: 'rgba(13, 110, 253, 0.8)',
        success: 'rgba(25, 135, 84, 0.8)',
        danger: 'rgba(220, 53, 69, 0.8)',
        warning: 'rgba(255, 193, 7, 0.8)',
        info: 'rgba(13, 202, 240, 0.8)',
        secondary: 'rgba(108, 117, 125, 0.8)',
        light: 'rgba(248, 249, 250, 0.8)',
        dark: 'rgba(33, 37, 41, 0.8)',
    }
};
/**
 * Get theme-aware colors based on current theme
 * @returns Color palette for current theme
 */
export function getThemeColors() {
    const theme = document.documentElement.getAttribute('data-bs-theme');
    return theme === 'dark' ? chartColors.dark : chartColors.light;
}
/**
 * Get a color from the theme palette
 * @param colorName - Name of the color to retrieve
 * @returns Color string
 */
export function getThemeColor(colorName) {
    return getThemeColors()[colorName];
}
/**
 * Generate a color with specified opacity
 * @param color - Base color in hex or rgba format
 * @param opacity - Opacity value (0-1)
 * @returns Color string with opacity
 */
export function colorWithOpacity(color, opacity) {
    // Parse hex color
    if (color.startsWith('#')) {
        const r = parseInt(color.slice(1, 3), 16);
        const g = parseInt(color.slice(3, 5), 16);
        const b = parseInt(color.slice(5, 7), 16);
        return `rgba(${r}, ${g}, ${b}, ${opacity})`;
    }
    // Handle rgba/rgb format
    if (color.startsWith('rgb')) {
        const parts = color.match(/[\d.]+/g);
        if (parts && parts.length >= 3) {
            return `rgba(${parts[0]}, ${parts[1]}, ${parts[2]}, ${opacity})`;
        }
    }
    // Return as-is if format is unknown
    return color;
}
/**
 * Generate a color with specified opacity from theme palette
 * @param colorName - Name of the color to retrieve
 * @param opacity - Opacity value (0-1)
 * @returns Color string with opacity
 */
export function getThemeColorWithOpacity(colorName, opacity) {
    return colorWithOpacity(getThemeColor(colorName), opacity);
}
